module.exports = __webpack_public_path__ + "static/media/spkr_bg.11457ed4.png";